module.exports = __webpack_public_path__ + "img/anuja6.8a5a5871.jpeg";